import React from 'react';
import Button from 'components/elements/button';
import Span from 'components/elements/span';
import { useDispatch } from 'react-redux';
import { removeFromMyLists, addToMyLists } from 'redux/reducers/myLists';
import styled, { css } from 'styled-components/macro';
import { ThemeProps } from 'types/styled';
import { rgba } from 'polished';
import { ReactComponent as IconCheckmark } from 'icons/icon-checkmark.svg';
import {
  followButtonStyles,
  animateCheckmark,
} from 'components/styled/FollowEntityButton/FollowEntityButton';

const toggleIsNotAdded = ({ isDisabled }: { isDisabled: boolean }): any => css`
  background-color: white;
  color: ${({ theme }): any => theme.NightBlue};
  border: 1px solid transparent;
  font-weight: 600;
  min-width: 9ch;

  &:hover {
    background-color: ${({ theme }): any => theme.Sand};
  }

  &:active {
    ${({ theme }): any =>
      !isDisabled && `background-color: ${theme.LightGrey};`};
  }
`;

const toggleIsAdded = (): any => css`
  background-color: none;
  color: white;
  border: 1px solid;
  min-width: 14ch;

  &:hover {
    background-color: ${({ theme }): any => rgba(theme.NightBlue, 0.1)};
  }

  &:active {
    background-color: ${({ theme }): any => rgba(theme.NightBlue, 0.15)};
  }

  .icon-checkmark {
    stroke-dasharray: 100;
    animation: ${animateCheckmark} 0.75s forwards;
  }
`;

const AddRemoveButton = styled(Button)<ThemeProps<'button'>>`
  ${followButtonStyles}

  margin-right: ${({ theme }): string => `${theme.spacing.xsmall}`};

  ${({ isInMyLists }): any => (isInMyLists ? toggleIsAdded : toggleIsNotAdded)}
`;

interface IAddToMyListsButtonProps {
  isInMyLists: boolean;
  listId: string;
}

const AddToMyListsButton: React.FC<IAddToMyListsButtonProps> = (props) => {
  const { isInMyLists, listId } = props;
  const dispatch = useDispatch();

  const handleOnClick = (): void => {
    if (isInMyLists) {
      dispatch(removeFromMyLists([listId]));
    } else {
      dispatch(addToMyLists(listId));
    }
  };

  return (
    <AddRemoveButton onClick={handleOnClick} isInMyLists={isInMyLists}>
      {!isInMyLists && <Span>Add to my lists</Span>}
      {isInMyLists && (
        <>
          <IconCheckmark />
          <Span>Added to my lists</Span>
        </>
      )}
    </AddRemoveButton>
  );
};

export default AddToMyListsButton;
